import { databases } from '../lib/appwrite';
import { ID, Query } from 'appwrite';

const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID;
const REVIEW_COLLECTION_ID = process.env.REACT_APP_APPWRITE_REVIEW_COLLECTION_ID;

/**
 * Create a new review
 * reviewData: { reviewerId, reviewedId, rating, title, description, orderItemId }
 */
export const createReview = async (reviewData) => {
  try {
    if (!DATABASE_ID || !REVIEW_COLLECTION_ID) {
      throw new Error('Review collection is not configured');
    }

    const review = await databases.createDocument(
      DATABASE_ID,
      REVIEW_COLLECTION_ID,
      ID.unique(),
      {
        reviewer_id: reviewData.reviewerId,
        reviewed_id: reviewData.reviewedId,
        rating: reviewData.rating,
        title: reviewData.title || '',
        description: reviewData.description || '',
        order_item_id: reviewData.orderItemId || null
      }
    );

    return review;
  } catch (error) {
    console.error('Error creating review:', error);
    throw error;
  }
};

export const getReviewsByVendorId = async (vendorId) => {
  try {
    if (!DATABASE_ID || !REVIEW_COLLECTION_ID) {
      throw new Error('Review collection is not configured');
    }

    const response = await databases.listDocuments(DATABASE_ID, REVIEW_COLLECTION_ID, [
      Query.equal('reviewed_id', vendorId),
      Query.orderDesc('$createdAt')
    ]);

    return response.documents;
  } catch (error) {
    console.error('Error fetching reviews for vendor:', error);
    throw error;
  }
};

export const getReviewsByOrderItemId = async (orderItemId) => {
  try {
    if (!DATABASE_ID || !REVIEW_COLLECTION_ID) return [];
    const response = await databases.listDocuments(DATABASE_ID, REVIEW_COLLECTION_ID, [
      Query.equal('order_item_id', orderItemId)
    ]);
    return response.documents;
  } catch (error) {
    console.error('Error fetching reviews for order item:', error);
    throw error;
  }
};

export const getReviewByOrderItemId = async (orderItemId) => {
  const reviews = await getReviewsByOrderItemId(orderItemId);
  return reviews.length > 0 ? reviews[0] : null;
};

export const getAverageRatingByVendorId = async (vendorId) => {
  try {
    const reviews = await getReviewsByVendorId(vendorId);
    if (!reviews || reviews.length === 0) return null;

    const sum = reviews.reduce((acc, r) => acc + (parseFloat(r.rating) || 0), 0);
    const avg = sum / reviews.length;
    // Round to 1 decimal place (to support half-star display like 4.5)
    return Math.round(avg * 10) / 10;
  } catch (error) {
    console.error('Error calculating average rating:', error);
    return null;
  }
};